import { Navigate, useLocation } from 'react-router-dom';

/**
 * Redirect onto a `/settings?tab=…` tab, carrying every other query parameter
 * along.
 *
 * A bare `<Navigate to="/settings?tab=sms">` drops the query it was reached
 * with. For the Zarinpal return paths that query is `?payment=…&ref=…` — the
 * only word the owner gets about their money — so it has to survive. The path
 * decides the tab: a `tab` in the incoming query is overwritten.
 */
export function TabRedirect({ tab }: { tab: string }) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set('tab', tab);
  return <Navigate to={`/settings?${params.toString()}`} replace />;
}
